import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { lazy } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { Container } from '@che-ins-ui/container';
import { CherehapaLogoIcon } from '@che-ins-ui/icons/CherehapaLogoIcon';
import { PhoneIcon } from '@che-ins-ui/icons/PhoneIcon';
import { Contacts } from '@che-ins-ui/contacts';
import { TravelForm } from '@/components/TravelForm';
import { apiIsApiDataLoadingSelector } from '@/models/api/selectors';
import AppLoader from '@/components/common/AppLoader';
import { isLogoSelector } from '@/models/request/selectors';
import { useStyles } from './components/styles';
import { Steps } from './components/Steps';
import { InsuranseCompanies } from './components/InsuranseCompanies';
const SmoothDropdown = lazy(() => import('../common/Header/SmoothDropdown'));
const WidgetPage = () => {
    const apiIsLoading = useSelector(apiIsApiDataLoadingSelector);
    const classes = useStyles();
    const isLogo = useSelector(isLogoSelector);
    if (apiIsLoading) {
        return _jsx(AppLoader, {});
    }
    return (_jsxs("div", { className: classes.wrapper, children: [_jsx("div", { className: classNames(classes.header, isLogo && classes.headerWithLogo), children: isLogo && _jsx(CherehapaLogoIcon, {}) }), _jsxs(Container, { appearance: "white-label-search-form", children: [_jsxs("div", { className: classes.titleWrapper, children: [_jsx("h1", { className: classes.title, children: "\u0422\u0443\u0440\u0438\u0441\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u043A\u0430" }), isLogo && (_jsx(SmoothDropdown, { baseAppearance: "base", appearance: "white-label-help", title: _jsxs(_Fragment, { children: [_jsx(PhoneIcon, { className: classes.phoneIcon }), "\u041D\u0443\u0436\u043D\u0430 \u043F\u043E\u043C\u043E\u0449\u044C?"] }), children: _jsx("div", { style: { padding: '12px' }, children: _jsx(Contacts, {}) }) }))] }), _jsx(TravelForm, {}), _jsx(Steps, {})] }), _jsx(InsuranseCompanies, {})] }));
};
export default WidgetPage;
